import { ApiService } from '@shared/api';

class SettingsService extends ApiService {
  // eslint-disable-next-line
  constructor(props) {
    super(props);

    this.baseUrl = '/settings'; 
  }

  async getSettings() {
    return await this.instance.get(this.baseUrl);
  }

  async getProduct(userId) {
    return await this.instance.get(`/products/${userId}`);
  }

  async patreon() {
    return await this.instance.get('/products/patreon');
  }

  async getPatreonOuath() {
    return await this.instance.get('/products/patreon/oauth/redirect');
  }

  async getPatreonMember(userId) {
    return await this.instance.get(`/products/patreon/members/${userId}`);
  }

  async getPlugin() {
    return await this.instance.post(`/products/plugin/get`, '{}',
      { responseType: "blob" }
    );
  }

  async getPluginInfo() {
    return await this.instance.get('/products/plugin/info');
  }
}

const settingService = new SettingsService();

export default settingService;
